import common from "./common.json";
import errors from "./errors.json";
import locations from "./locations.json";

export const es = {
    translation: common,
    error: errors,
    locations,
};
